import React, { useEffect, useState } from "react";
import { Form, Formik } from "formik";
import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Alert,
  AlertIcon,
  AlertTitle,
} from "@chakra-ui/react";
import { setFormModal } from "../redux/slices/modalSlice";
import { useDispatch } from "react-redux";
import { addusertypeFormSchema } from "../utils/formValidationSchema";
import { createUserType, fetchRoleNames } from "../redux/slices/userTypeSlice";
import { MultiSelect } from "chakra-multiselect";

const AddNewUser = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [roles, setRoles] = useState([]);
  const [rolesValue, setRolesValue] = useState([]);

  const initialValues = {
    email: "",
    phoneNumber: "",
    firstName: "",
    lastName: "",
    roleNames: "",
  };

   useEffect(() => {
    async function getRoleNames() {
      const response = await dispatch(fetchRoleNames());
      if (response?.payload) {
        setRoles(response.payload);
      }
    }
    getRoleNames();
  }, [dispatch]);
  const roleOptions = roles.map((role) => ({
    label: role.name,
    value: role.id,
  }));

  const handleSubmit = async (values) => {
    setLoading(true);
    setError("");
    try {
      const formData = {
        email: values.email,
        phoneNumber: values.phoneNumber,
        firstName: values.firstName,
        lastName: values.lastName,
        roleNames: rolesValue.map((item) => item.value),
      };
      const response = await dispatch(createUserType(formData));
      console.log(response);
      setLoading(false);
      dispatch(setFormModal({ status: false }));
    } catch (error) {
      setError(error?.message || "Something went wrong. Please try again");
    }
  };

  return (
    <>
      {error && (
        <Alert status="error" className="mt-3">
          <AlertIcon />
          <AlertTitle>{error}</AlertTitle>
        </Alert>
      )}
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={addusertypeFormSchema}
        onSubmit={(values) => handleSubmit(values)}
      >
        {({ errors, touched, values, handleBlur, handleChange }) => (
          <Form>
            <FormControl
              mt={4}
              isInvalid={errors.email && touched.email}
              color="#121212"
              fontFamily={"inter"}
            >
              <FormLabel htmlFor="email" fontSize={"16px"}>
                Email
              </FormLabel>
              <Input
                placeholder="Enter Email"
                fontSize={"small"}
                bg={"#F3F3F3"}
                name="email"
                focusBorderColor="#ffffff"
                borderRadius={"0"}
                borderColor={"#FFFFFF"}
                _placeholder={{ color: "#B4B1B1" }}
                _hover={{ borderColor: "#FFFFFF" }}
                type="text"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values?.email}
              />
              {touched.email && errors.email && (
                <FormErrorMessage>{errors.email}</FormErrorMessage>
              )}
            </FormControl>
            <FormControl
              mt={4}
              isInvalid={errors.phoneNumber && touched.phoneNumber}
              color="#121212"
              fontFamily={"inter"}
            >
              <FormLabel htmlFor="phoneNumber" fontSize={"16px"}>
                Phone Number
              </FormLabel>
              <Input
                placeholder="Enter Phone Number"
                fontSize={"small"}
                bg={"#F3F3F3"}
                name="phoneNumber"
                focusBorderColor="#ffffff"
                borderRadius={"0"}
                borderColor={"#FFFFFF"}
                _placeholder={{ color: "#B4B1B1" }}
                _hover={{ borderColor: "#FFFFFF" }}
                type="text"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values?.phoneNumber}
              />
              {touched.phoneNumber && errors.phoneNumber && (
                <FormErrorMessage>{errors.phoneNumber}</FormErrorMessage>
              )}
            </FormControl>
            <FormControl
              mt={4}
              isInvalid={errors.lastName && touched.lastName}
              color="#121212"
              fontFamily={"inter"}
            >
              <FormLabel htmlFor="firstName" fontSize={"16px"}>
                First Name
              </FormLabel>
              <Input
                placeholder="Enter First Name"
                fontSize={"small"}
                bg={"#F3F3F3"}
                name="firstName"
                focusBorderColor="#ffffff"
                borderRadius={"0"}
                borderColor={"#FFFFFF"}
                _placeholder={{ color: "#B4B1B1" }}
                _hover={{ borderColor: "#FFFFFF" }}
                type="text"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values?.firstName}
              />
              {touched.firstName && errors.firstName && (
                <FormErrorMessage>{errors.firstName}</FormErrorMessage>
              )}
            </FormControl>

            <FormControl
              mt={4}
              isInvalid={errors.lastName && touched.lastName}
              color="#121212"
              fontFamily={"inter"}
            >
              <FormLabel htmlFor="lastName" fontSize={"16px"}>
                Last Name
              </FormLabel>
              <Input
                placeholder="Enter Last Name"
                fontSize={"small"}
                bg={"#F3F3F3"}
                name="lastName"
                focusBorderColor="#ffffff"
                borderRadius={"0"}
                borderColor={"#FFFFFF"}
                _placeholder={{ color: "#B4B1B1" }}
                _hover={{ borderColor: "#FFFFFF" }}
                type="tel"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values?.lastName}
              />
              {touched.lastName && errors.lastName && (
                <FormErrorMessage>{errors.lastName}</FormErrorMessage>
              )}
            </FormControl>
            <FormControl mt={4} color="#121212" fontFamily={"inter"}>
              <FormLabel fontSize={"16px"}>Role Name</FormLabel>
              {roles.length > 0 && (
                <MultiSelect
                  options={roleOptions}
                  value={rolesValue}
                  label=""
                  required={true}
                  onChange={setRolesValue}
                />
              )}
            </FormControl>

            <Button
              mt={10}
              width={"100%"}
              background={"#22944E"}
              _hover={{ background: " " }}
              color={"#FFFFFF"}
              type="submit"
              isLoading={loading}
              loadingText="Saving ..."
            >
              Save
            </Button>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default AddNewUser;
